import type { ValidationErrors } from '@angular/forms';

interface LengthError {
  requiredLength: number;
}

interface RangeError {
  min?: number;
  max?: number;
}

/**
 * Angular Validators 에러 → 한글 메시지.
 * 필드 래퍼가 이 메시지를 표시한다 — 서버 400 message는 각 컴포넌트의 error 입력으로
 * 같은 자리에 표시해 검증 표시 위치를 이원화하지 않는다.
 */
export function koreanValidationMessage(errors: ValidationErrors): string {
  if (errors['required'] !== undefined) {
    return '필수 입력 항목입니다.';
  }
  if (errors['minlength'] !== undefined) {
    return `최소 ${(errors['minlength'] as LengthError).requiredLength}자 이상 입력하세요.`;
  }
  if (errors['maxlength'] !== undefined) {
    return `최대 ${(errors['maxlength'] as LengthError).requiredLength}자까지 입력할 수 있습니다.`;
  }
  if (errors['email'] !== undefined) {
    return '이메일 형식이 올바르지 않습니다.';
  }
  if (errors['min'] !== undefined) {
    return `${(errors['min'] as RangeError).min} 이상이어야 합니다.`;
  }
  if (errors['max'] !== undefined) {
    return `${(errors['max'] as RangeError).max} 이하여야 합니다.`;
  }
  if (errors['pattern'] !== undefined) {
    return '입력 형식이 올바르지 않습니다.';
  }
  // 전문 필드 검증기(features/products/transfer-version.ts)가 사유를 직접 담아 보낸다
  const transferField = errors['transferField'];
  if (
    transferField !== null &&
    typeof transferField === 'object' &&
    'message' in transferField &&
    typeof transferField.message === 'string'
  ) {
    return transferField.message;
  }
  return '입력값을 확인하세요.';
}
